exports = module.exports = require("../../../../apps/experimentation-ui/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ane-WithCallout {\n  display: inline-block;\n}\n\n.ane-WithCallout-callout {\n  padding: 20px;\n}\n\n.ane-WithCallout-title {\n  margin: 0;\n  font-size: 21px;\n  font-weight: 100;\n  color: #343f51;\n  font-weight: 300;\n}", ""]);

